import * as React from "react"
import { SkipNavContent, SkipNavLink } from "./skip-nav"
import { Header } from "./header"
import { Navigation } from "./navigation"
import { Footer } from "./footer"
import { FooterLite } from "./footer-lite"
import { Seo } from "./seo"
import { CookieConsent } from "./cookie-consent"

import {
  wrapper
} from "./layout.module.css"

export function Layout({ location, lite, children }) {
  return (
    <>
      {
        lite ? (<>
          <Seo />
          <Header />
          <Navigation />
          <SkipNavContent className={wrapper} > {children}</SkipNavContent>
          <FooterLite />
        </>)
          : (<>
            <Seo />
            <SkipNavLink />
            <Header />
            <Navigation />
            <SkipNavContent className={wrapper}>{children}</SkipNavContent>
            <Footer />
            <CookieConsent />
          </>)
      }
    </>)
}
